import React from 'react';
import { defaultTheme } from './../../styles/theme/default';

export function DropdownIcon ({ rotate, color = 'oxfordBlue' }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      fill="none"
      viewBox="0 0 12 13"
      style={{ transform: `rotate(${rotate}deg)` }}
    >
      <path
        stroke={defaultTheme.colors[color]}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M10.688 4.364L6.22 9.181v0a.296.296 0 01-.442 0s0 0 0 0L1.313 4.364"
      />
    </svg>
  );
}
